import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { format } from 'date-fns';

import AsyncDatePicker from 'components/AsyncDatePicker';

// Actions
import { updateQueryString, deleteQueryString } from 'services/router/actions';

// Workspaces
import { makeSelectQueryStringValue } from 'workspaces/react-router-selectors';

interface Props {
    singleFilter?: boolean;
}

const DateRangePicker = ({ singleFilter }: Props): React.ReactElement => {
    const dispatch = useDispatch();

    const startDateQS: string | undefined = useSelector(
        makeSelectQueryStringValue('startDate')
    );
    const endDateQS: string | undefined = useSelector(
        makeSelectQueryStringValue('endDate')
    );
    const [startDate, setStartDate] = useState<Date | null>(
        startDateQS ? new Date(startDateQS) : null
    );
    const [endDate, setEndDate] = useState<Date | null>(
        endDateQS ? new Date(endDateQS) : null
    );

    const handleChange = ([start, end]: [Date | null, Date | null]) => {
        setStartDate(start);
        setEndDate(end);

        if (start && end) {
            if (singleFilter) dispatch(deleteQueryString());

            dispatch(
                updateQueryString({
                    startDate: format(start, 'yyyy-MM-dd'),
                    endDate: format(end, 'yyyy-MM-dd')
                })
            );
        }
    };

    return (
        <AsyncDatePicker
            placeholderText="Pick date range"
            selected={startDate || new Date()}
            dateFormat="dd/MM/yyyy"
            onChange={handleChange}
            startDate={startDate}
            endDate={endDate}
            selectsRange
            locale="nz"
        />
    );
};

DateRangePicker.defaultProps = {
    singleFilter: false
};

export default DateRangePicker;
